import { render, staticRenderFns } from "./TheProfileForm.vue?vue&type=template&id=dee63cb6&"
import script from "./TheProfileForm.vue?vue&type=script&lang=js&"
export * from "./TheProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileForm.vue?vue&type=style&index=0&id=dee63cb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports